<div class="title-container">
    <h1>{{ title }}</h1>
    <span class="subtitle">{{ subtitle }}</span>
    <span *ngIf="subtitle2" class="subtitle">{{ subtitle2 }}</span>
  </div>
  